// Jquery
import $ from "jquery";

// Umbraco Forms
import 'jquery-validation/dist/jquery.validate.min';
import 'jquery-validation-unobtrusive/dist/jquery.validate.unobtrusive.min';

// Bootstrap
import 'bootstrap';

// AOS
import AOS from 'aos';


// MultiDigital JS
import './multidigital.js';

import './multiMostRead.js';

// MultiForms
import './multiForms/multiForms.js'

// Multi Paper
import './multiPaper/multiPaper.js'

// Custom JS
import {createApp} from 'vue';
import Paginate from "vuejs-paginate-next";

//Datepicker
import Datepicker from '@vuepic/vue-datepicker';
import '@vuepic/vue-datepicker/dist/main.css'

//VueAwesomePaginate
import VueAwesomePaginate from "vue-awesome-paginate";
import "vue-awesome-paginate/dist/style.css";

import Vuex from 'vuex';
import MdGemeindeSearch from './Components/GemeindeSearch.vue';
import MdAgendaFilter from './Components/AgendaFilter.vue';
import MdInstagramFeed from './Components/InstagramFeed.vue';

import MdPager from './Components/Pager.vue';
import MdPaperList from './Components/PaperList.vue';
import MdPaperSearch from './Components/PaperSearch.vue';

AOS.init()

let elements = document.getElementsByClassName('md-app');
for (let el of elements) {
    let app = createApp({    
        components: {
            MdGemeindeSearch,
            MdAgendaFilter,
            MdInstagramFeed,
            MdPager,
            MdPaperList,
            MdPaperSearch
        },
        methods: {
            handlePaginationClick(page) {
                window.location.href = window.location.href.replace(/&page=\d+/, "&page=" + page);
                if (!window.location.href.includes("page=")) {
                    window.location.href = window.location.href + "&page=" + page;
                }
            }
        }
    });
    app.component('Datepicker', Datepicker);
    app.component("paginate", Paginate);
    app.use(VueAwesomePaginate);
    app.mount(el);
}